<script setup>
/**
 * Three-dot "living ellipsis" for loading states (GH-934) — a nod to the
 * legacy multi-colored throbber's staggered opacity wave, recolored with the
 * redesign gradient's stops. Sized in em so it rides along with whatever
 * text it follows ("Saving", "Creating", …).
 *
 * On dark fills the amber→orange→red dots read as-is; pass `variant="mono"`
 * for a currentColor version when the colored dots would clash.
 */
defineProps({
    variant: {
        type: String,
        default: "brand", // "brand" | "mono"
    },
});

const DOT_DELAYS = ["0ms", "150ms", "300ms"];

const BRAND_DOT_COLORS = ["#ffb545", "#fc7440", "#f21439"];
</script>

<template>
    <span
        class="inline-flex items-baseline gap-[0.18em]"
        role="status"
        aria-label="Loading"
    >
        <span
            v-for="(delay, index) in DOT_DELAYS"
            :key="index"
            class="inline-block size-[0.28em] animate-throb rounded-full"
            :class="variant === 'mono' ? 'bg-current' : ''"
            :style="{
                animationDelay: delay,
                ...(variant === 'brand'
                    ? { backgroundColor: BRAND_DOT_COLORS[index] }
                    : {}),
            }"
        ></span>
    </span>
</template>
